module.exports = __webpack_public_path__ + "static/media/addMemberBlackIcon.e8414e17.svg";